import className from 'classnames';
import React from 'react';

import Button, { BUTTON_STYLES } from '@commons/Button';

import styles from './cookieBannerPanelAction.scss';

//----------------------------------------------------------------------
// UTILS
//----------------------------------------------------------------------
export const COOKIE_BANNER_PANEL_ACTION_VARIANT = {
  contained: 'CONTAINED',
  outlined: 'OUTLINED',
  text: 'TEXT'
};
const buttonClassNameMapping = {
  [COOKIE_BANNER_PANEL_ACTION_VARIANT.contained]: BUTTON_STYLES.PRIMARY,
  [COOKIE_BANNER_PANEL_ACTION_VARIANT.outlined]: styles.outlined,
  [COOKIE_BANNER_PANEL_ACTION_VARIANT.text]: styles.text
};

interface CookieBannerPanelActionProps {
  // Variants
  variant?: unknown[];
  full?: boolean;
  // Other Props
  name: string;
  children: React.ReactNode;
  onClick: (...args: unknown[]) => unknown;
  id?: string;
}

//----------------------------------------------------------------------
// COMPONENT
//----------------------------------------------------------------------

const CookieBannerPanelAction = React.forwardRef<HTMLElement, CookieBannerPanelActionProps>(
  ({ name, children, onClick, full, variant, id }, ref) => {
    const containerClassName = className(styles.container, {
      [styles.full]: full
    });
    const buttonClassName = className(styles.button, buttonClassNameMapping[variant]);
    return (
      <Button
        type="button"
        caption={children}
        onClickCallBack={onClick}
        styling={buttonClassName}
        containerStyles={containerClassName}
        name={name}
        domId={id}
        ref={ref}
      />
    );
  }
);
CookieBannerPanelAction.defaultProps = {
  full: false,
  variant: COOKIE_BANNER_PANEL_ACTION_VARIANT.contained,
  // eslint-disable-next-line react/default-props-match-prop-types
  name: ''
};
export default CookieBannerPanelAction;
